/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ProjectEntry, ProjectEntry$inboundSchema } from "./projectentry.js";

export type OrganizationEntry = {
  id: string;
  name: string;
  projects: Array<ProjectEntry>;
  /**
   * Whether SCIM directory sync is enabled for this organization (synced from WorkOS)
   */
  scimEnabled?: boolean | undefined;
  slug: string;
  /**
   * Whether SSO is enabled for this organization (synced from WorkOS)
   */
  ssoEnabled?: boolean | undefined;
  userWorkspaceSlugs?: Array<string> | undefined;
};

/** @internal */
export const OrganizationEntry$inboundSchema: z.ZodMiniType<
  OrganizationEntry,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.string(),
    projects: z.array(ProjectEntry$inboundSchema),
    scim_enabled: z.optional(z.boolean()),
    slug: z.string(),
    sso_enabled: z.optional(z.boolean()),
    user_workspace_slugs: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "scim_enabled": "scimEnabled",
      "sso_enabled": "ssoEnabled",
      "user_workspace_slugs": "userWorkspaceSlugs",
    });
  }),
);

export function organizationEntryFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationEntry' from JSON`,
  );
}
